import React from 'react';
import logo from './logo.svg';
import './App.scss';
import { RouterProvider } from 'react-router-dom';
import { createAppRouter } from './Helpers/AppRoutes';
import { useSelector } from 'react-redux';
import { ConfirmationProvider } from './Components/ConfirmationDialog';
import ToastContainer from './Components/Toast/ToastContainer';
import { ErrorBoundary } from 'react-error-boundary';
import Fallback from './Components/ErrorBoundary';
import "react-range-slider-input/dist/style.css";
import useFlexbusTimerCleanup from './Hooks/useFlexbusTimerCleanup';

function App() {
  const isAuthenticated = useSelector((state: any) => state.AuthSlice.isAuthenticated);
  const theme: string = useSelector((state: any) => state.ThemeSlice.theme);
  const router = createAppRouter(isAuthenticated);

  useFlexbusTimerCleanup();

  React.useEffect(() => {
    document.documentElement.className = theme;
  }, [theme]);


  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <ConfirmationProvider>
        <RouterProvider router={router} />
        <ToastContainer />
      </ConfirmationProvider>
    </ErrorBoundary>
  );
}

export default App;